import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useNavigate, useParams } from 'react-router-dom'
import { InvoiceService } from 'utility'
import { CaretLeft } from 'phosphor-react'

const ViewerContainer = styled.div`
    padding: 1rem 0;
    .i-frame {
        height: 80vh;
        width: 100%;
        border: 0;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
`

export const InvoiceViewScreen = () => {
    const { id } = useParams()
    const navigate = useNavigate()

    const [src, setSrc] = useState('')
    const [error, setError] = useState(null)

    const renderContent = () => {
        if (src) {
            return <iframe src={src} className="i-frame" title="Invoice PDF" />
        }
        if (error) {
            return <div className="text-danger p-3 bg-red-50 rounded">Failed to load invoice PDF</div>
        }
        return <div className="p-3 text-muted">Loading invoice PDF...</div>
    }

    useEffect(() => {
        let alive = true
        let objectUrl = ''

        const loadPdf = async () => {
            try {
                const res = await InvoiceService.getPdf(id)
                objectUrl = res.PdfUrl
                if (alive) setSrc(objectUrl)
            } catch (e) {
                if (alive) setError(e)
            }
        }

        loadPdf()
        return () => {
            alive = false
            if (objectUrl) URL.revokeObjectURL(objectUrl)
        }
    }, [id])

    return (
        <ViewerContainer>
            <div
                className="d-inline-flex align-items-center pointer py-2 px-3 bg-light rounded border mb-3"
                onClick={() => navigate(-1)}
            >
                <CaretLeft size={20} />
                <span className="ms-2 fw-semibold">Back</span>
            </div>
            <div>
                {renderContent()}
            </div>
        </ViewerContainer>
    )
}
